import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useEffect, useState } from "react";
import { advisorGradeStatus, finalRecommendations } from "../../../Constants";
import AdvisorGradeModal from "./AdvisorGradeModal";
import GradeBox from "./GradeBox";
import PanelGradeModal from "./PanelGradeModal";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5%",
    paddingBottom: 15,
  },
}));

const getRecommendText = (recommend) => {
  const recommendation = finalRecommendations.filter(
    (r) => r.value === recommend
  );
  if (!recommendation || recommendation.length === 0) return "---";
  else return recommendation[0].label;
};

export default function GradeAndRank(props) {
  const classes = useStyles();
  const {
    proposal,
    totalProposalsNumber,
    advisorTotalProposalNumber,
    refreshProposals,
    assignToMe,
  } = props;
  const [advisorGradeOpen, setAdvisorGradeOpen] = useState(false);
  const [panelGradeOpen, setPanelGradeOpen] = useState(false);
  const [advisorGradeReadOnly, setAdvisorGradeReadOnly] = useState(false);
  const [panelGradeReadOnly, setPanelGradeReadOnly] = useState(false);
  const [proposalAdvisor, setProposalAdvisor] = useState(
    proposal.proposalAdvisors[0]
  );

  useEffect(() => {
    setProposalAdvisor(proposal?.proposalAdvisors[0]);
  }, [proposal]);
  return (
    <Grid container className={classes.root} style={{ textAlign: "center" }}>
      <Grid item xs={6}>
        <GradeBox
          title="Advisor"
          openGarde={(readOnly) => {
            setAdvisorGradeOpen(true);
            setAdvisorGradeReadOnly(readOnly);
          }}
          notAssgin={proposalAdvisor === null || proposalAdvisor === undefined}
          grade={getRecommendText(proposalAdvisor?.advisorRecommend)}
          rank={`${proposalAdvisor?.advisorRanking || "---"}`}
          notAssignToMe={!assignToMe}
          totalProposalNumber={advisorTotalProposalNumber}
          viewOnly={proposalAdvisor?.gradeStatus===advisorGradeStatus.SendFinalRecommendationThankYou}
        />
        <AdvisorGradeModal
          readOnly={advisorGradeReadOnly}
          refreshProposals={refreshProposals}
          proposalAdvisor={proposalAdvisor}
          open={advisorGradeOpen}
          totalProposalsNumber={advisorTotalProposalNumber}
          onClose={() => setAdvisorGradeOpen(false)}
        />
      </Grid>
      <Grid item xs={6}>
        <GradeBox
          title="Panel"
          panel
          grade={getRecommendText(proposal?.proposalFinalGrade)}
          openGarde={(readOnly) => {
            setPanelGradeOpen(true);
            setPanelGradeReadOnly(readOnly);
          }}
          rank={`${proposal?.proposalFinalRank || "---"}`}
          totalProposalNumber={totalProposalsNumber}
          viewOnly={proposal.finalRankSent}
        />
        <PanelGradeModal
          readOnly={panelGradeReadOnly}
          refreshProposals={refreshProposals}
          proposal={proposal}
          open={panelGradeOpen}
          totalProposalsNumber={totalProposalsNumber}
          onClose={() => setPanelGradeOpen(false)}
        />
      </Grid>
    </Grid>
  );
}
